module.exports = __webpack_public_path__ + "static/img/youxiao.79a52bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/deptimg/youxiao.jpg
// module id = ER0E
// module chunks = 6